import React, { ReactElement } from 'react';
import { Loader } from 'idsk-react-components';
import { Breadcrumbs, HiddenPriorityTitle, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { useLocation } from 'react-router';
import TezaurusList from '../../../module/Admin/Tezaurus/List/TezaurusList';
import useTezaurusList from '../../../module/Admin/Tezaurus/List/hook/useTezaurusList';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';

const TezaurusListPage = (): ReactElement => {
  const { tezaurusList, tezaurusStatus, reloadTezaurusList } = useTezaurusList();
  const { pathname } = useLocation();

  return (
    <Layout>
      <HiddenPriorityTitle>Administrácia tezaurov</HiddenPriorityTitle>
      <Loader loading={tezaurusStatus?.loading}>
        <>
          <Breadcrumbs routeList={[
            homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
            {
              to: pathname,
              heading: 'Administrácia tezaurov',
            },
          ]}
          />
          <GlobalErrors />
          <SecuredPage
            allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS, UserRoleEnum.REDAKTOR_TEZAURUS]}
          >
            <>
              <PageHeadingWithBackButton heading="Administrácia tezaurov" />
              <TezaurusList tezaurusList={tezaurusList} reloadTezaurusList={reloadTezaurusList} />
            </>
          </SecuredPage>
        </>
      </Loader>
    </Layout>
  );
};

export default TezaurusListPage;
